import React from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ChipButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  margin-top: 4px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  cursor: ${({ active }) => (active ? "default" : "pointer")};
  background: ${({ theme, active }) =>
    active
      ? theme.primary
      : theme.type === "light"
      ? theme.gray.gray100
      : theme.gray.gray800};
  color: ${({ theme, active }) => (active ? "#fff" : theme.text.secondary)};
  border: 1px solid
    ${({ theme, active }) => (active ? theme.primary : theme.divider)};
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover {
    ${({ active, theme }) =>
      active
        ? ""
        : `
      color: ${theme.text.primary};
      border-color: ${theme.primary};
    `}
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primary};
    outline-offset: 2px;
  }
`;

export default function ResultChip({ active, onClick }) {
  return (
    <ChipButton
      active={active}
      onClick={active ? undefined : onClick}
      type="button"
      aria-pressed={active}
    >
      <FontAwesomeIcon icon={["fal", "table"]} size="sm" />
      {active ? "Viewing results" : "View results"}
    </ChipButton>
  );
}
